<template>
  <p class="you-sure --bold">{{ message }}?</p>
  <p class="irreversible">{{ $t('form.messages.irreversible') }}</p>
  <form v-if="$route.query.admin == 'true'" class="form">
    <FormSelect :label="$t('form.label.deleteReason')" name="deleteReason" :options="deleteReasons"
      v-model="form.fields.reason" :message="$t('form.messages.reason')" required />
  </form>
</template>

<script>
import { FormSelect } from '@/components/form/fields'
import FormValidMixin from '@/components/form/mixins/FormValidMixin.js'

export default {
  name: 'DeleteConfirmation',
  mixins: [FormValidMixin],
  data() {
    return {
      form: {
        fields: {
          user_id: {
            value: 0,
            valid: true
          },
          reason: {
            value: '0',
            valid: false
          },
          title: {
            value: '',
            valid: true
          }
        },
        submitted: false
      },
      deleteReasons: [
        { key: this.$t('form.reasons.objective'), value: this.$t('form.reasons.objective') },
        { key: this.$t('form.reasons.rules'), value: this.$t('form.reasons.rules') },
        { key: this.$t('form.reasons.old'), value: this.$t('form.reasons.old') },
        { key: this.$t('form.reasons.pertinence'), value: this.$t('form.reasons.pertinence') },
        { key: this.$t('form.reasons.false'), value: this.$t('form.reasons.false') },
        { key: this.$t('form.reasons.double'), value: this.$t('form.reasons.double') },
        { key: this.$t('form.reasons.inapropriate'), value: this.$t('form.reasons.inapropriate') }
      ]
    }
  },
  components: {
    FormSelect
  },
  computed: {
    message() {
      return this.$t(`form.delete.${this.$route.query.model}.message`)
        .replace(':TITLE', this.model?.title ?? '')
    },
    model() {
      switch (this.$route.query.model) {
        case this.$query.MODEL.ACTUALITY:
          return Array.from(this.$actuality.all).find(({ id }) => id.toString() === this.$route.query.id.toString())
        case this.$query.MODEL.CATEGORY:
        case this.$query.MODEL.SUB_CATEGORY:
          return Array.from(this.$category.all).find(({ id }) => id.toString() === this.$route.query.id.toString())
        case this.$query.MODEL.DOCUMENT:
          return Array.from(this.$document.all).find(({ id }) => id.toString() === this.$route.query.id.toString())
        case this.$query.MODEL.EMPLOYEE:
          return Array.from(this.$employee.all).find(({ id }) => id.toString() === this.$route.query.id.toString())
        case this.$query.MODEL.EVENT:
          return Array.from(this.$event.all).find(({ id }) => id.toString() === this.$route.query.id.toString())
        case this.$query.MODEL.NOTICE:
          return Array.from(this.$notice.all).find(({ id }) => id.toString() === this.$route.query.id.toString())
        default:
          return null
      }
    }
  },
  methods: {
    async submit() {
      if(this.$route.query.admin == 'true' && !this.form.valid) if(!this.form.valid) return

      switch (this.$route.query.model) {
        case this.$query.MODEL.ACTUALITY:
          await this.$actuality.destroy(this.$route.query.id)
          break
        case this.$query.MODEL.CATEGORY:
        case this.$query.MODEL.SUB_CATEGORY:
          await this.$category.destroy(this.$route.query.id)
          break
        case this.$query.MODEL.DOCUMENT:
          await this.$document.destroy(this.$route.query.id)
          break
        case this.$query.MODEL.EMPLOYEE:
          await this.$employee.destroy(this.$route.query.id)
          break
        case this.$query.MODEL.EVENT:
          await this.$event.destroy(this.$route.query.id)
          break
        case this.$query.MODEL.NOTICE:
          if (this.$route.query.admin == 'true') {
            this.form.fields.title.value = this.model?.title ?? ''
            this.form.fields.user_id.value = this.model?.user_id ?? 0

            const formData = Object.entries(this.form.fields).reduce((acc, [fieldName, field]) => {
              acc[fieldName] = field.value

              return acc
            }, {})

            await this.$notification.store(formData)
          }
          await this.$notice.destroy(this.$route.query.id)
          break
      }

      this.$popup.report(`form.delete.${this.$route.query.model}.popup`)
    }
  }
}
</script>